// (Copyright) Confluent, Inc.
import { useRef, useEffect, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

export function Portal({ children }: { children: ReactNode }) {
  const portal = useRef(document.createElement('div'));
  const rootEl = useRef(document.body);

  useEffect(() => {
    portal.current.setAttribute('data-testid', 'Portal');
    // TODO resolve this hook violation Dylan
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portal.current]);

  useEffect(() => {
    const node = portal.current;

    rootEl.current != null && rootEl.current.appendChild(node);

    return () => {
      // TODO resolve this hook violation Dylan
      // eslint-disable-next-line react-hooks/exhaustive-deps
      rootEl.current != null && rootEl.current.removeChild(node);
    };
  }, []);

  return createPortal(children, portal.current);
}
